export const POST_CONFIRM_APPOINTMENT_REQUEST='confirmAppointmentReducer/POST_CONFIRM_APPOINTMENT_REQUEST'
export const POST_CONFIRM_APPOINTMENT_SUCCESS='confirmAppointmentReducer/POST_CONFIRM_APPOINTMENT_SUCCESS'
export const POST_CONFIRM_APPOINTMENT_FAILED='confirmAppointmentReducer/POST_CONFIRM_APPOINTMENT_FAILED'